import {createSelector} from 'reselect';
import { selectRootState } from '../../../store/selectors';

export const selectUserActivitiesState = createSelector(
    [selectRootState],
    state => state.userActivities,
  );



export const selectUserActivitiesLoading = createSelector([selectUserActivitiesState], 
    state => state.isLoading)


export const selectEmail = createSelector([selectUserActivitiesState], state => state.email)